module.exports = __webpack_public_path__ + "944614c012ef971b210082bbeb2edf0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/oscar.svg
// module id = 13
// module chunks = 0